/* unplugin-vue-components disabled */import { render } from "./slidedata.vue?vue&type=template&id=778750ff&scoped=true"
import script from "./slidedata.vue?vue&type=script&lang=js"
export * from "./slidedata.vue?vue&type=script&lang=js"

import "./slidedata.vue?vue&type=style&index=0&id=778750ff&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778750ff"]])

export default __exports__